import * as React from 'react';

import { CurrentCourseItem } from 'bundles/degree-home/components/v2/CurrentCourses/CurrentCourseItem';
import type { NormalizedInProgressCourse } from 'bundles/degree-home/components/v2/types/courseStates';

type Props = {
  inProgressCourses: Array<NormalizedInProgressCourse>;
};

export const CurrentCourses = ({ inProgressCourses }: Props) => {
  return (
    <div>
      {inProgressCourses.map((courseState) => {
        return <CurrentCourseItem key={courseState.id} courseState={courseState} />;
      })}
    </div>
  );
};
export default CurrentCourses;
